module.exports = __webpack_public_path__ + "assets/img/person_icon_d.4afb58e4.png";